/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsSubscriptionListItem,
    IdentityMelcoModelsSubscriptionListItemFromJSON,
    IdentityMelcoModelsSubscriptionListItemFromJSONTyped,
    IdentityMelcoModelsSubscriptionListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsSubscriptionListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem
     */
    list: Array<IdentityMelcoModelsSubscriptionListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsSubscriptionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsSubscriptionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


